import React, {useContext, useState} from 'react';
import {FormattedMessage} from "react-intl";

import ArrowButton from "components/button/ArrowButton";

import SidebarHeadingTitle from "../SidebarHeadingTitle";
import SidebarFloatMenu from "../SidebarFloatMenu";
import OrganizationName from "./components/OrganizationName";
import OrganizationEshopLink from "./components/OrganizationEshopLink";
import BottomDrawer from "../BottomDrawer";
import OrganizationSelectorMenuContent from "./components/OrganizationSelectorMenuContent";
import Notifications from "./components/Notifications";

import {SidebarContext} from "../../../../SidebarContext";

function OrganizationSelector(props) {
    const [anchorEl, setAnchorEl] = useState(null);

    const { currentOrganization, isMobile} = useContext(SidebarContext);

    function handleClick(event){
        setAnchorEl(event.currentTarget);
    }

    return (
        <div style={{
            paddingLeft: '12px',
            paddingRight: '12px'
        }}>
            <SidebarHeadingTitle>
                <FormattedMessage id='sidebar.organization.title' />
            </SidebarHeadingTitle>
            <ArrowButton
                onClick={(e) => handleClick(e)}
                open={!!anchorEl}
                doubleArrow
                endAdornment={!isMobile && <OrganizationEshopLink organization={currentOrganization} />}
            >
                <OrganizationName organization={currentOrganization} selected={true} />
            </ArrowButton>
            {isMobile ? (
                <BottomDrawer
                    open={!!anchorEl}
                    onClose={() => setAnchorEl(null)}
                    title={<FormattedMessage id='sidebar.organization.title' />}
                >
                    <OrganizationSelectorMenuContent />
                </BottomDrawer>
            ) : (
                <SidebarFloatMenu
                    anchorEl={anchorEl}
                    open={!!anchorEl}
                    onClose={() => setAnchorEl(null)}
                    style={{ marginTop: "20px" }}
                    paperSx={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}
                >
                    <OrganizationSelectorMenuContent />
                </SidebarFloatMenu>
            )}
            <Notifications />
        </div>
    );
}

export default OrganizationSelector;
